import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import Cookie from 'js-cookie';
import { ApiGateWay } from '../ApiGateWay/ApiGateWay';
import { Config } from '../config/config';
import { Helmet } from 'react-helmet';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import {isLoginOrNot} from '../pages/Store/actions/storeService';
import LZString from 'lz-string';

class Welcome extends Component {
  constructor(props) {
    super(props);
    localStorage.removeItem('Login');
    localStorage.removeItem('stores');
    localStorage.removeItem('warehouses');

    Cookie.remove('currentUser');
    Cookie.remove('stores');
    Cookie.remove('storesAll');
    Cookie.remove('warehouses');
    localStorage.removeItem('curStoreID');
    localStorage.removeItem('tabName');
    const config = JSON.parse(Config);
    this.state = {
      redirectionURL: '',
      title: 'Welcome to Decathlon',
      login: false,
      loading: false,
      message: '',
      userID: '',
      strData: [],
      wrData: [],
      storeCities: [],
      warehouseCities: [],
      storeCityEnabled: false,
      warehouseCityEnabled: false,
      navigate: false,
      apiInterface: config['api'],
      modalOpen: false,
      notAllowed: false,
      token: null,
    };
  }

  userChange = (event) => {
    this.setState({
      username: event.target.value,
    });
  };

  handleClose = () => {
    this.setState({
      modalOpen: false,
      message: '',
    });
  };



  setCookie = (value) => {
    console.log('SetCookie'. value);
    let data = JSON.stringify(value);
    document.cookie = "currentUser="+data+"; path=/; secure; sameSite=strict";
  }

  /* handleSubmit = (event) => {
    localStorage.setItem('userId', 'Z02SAHME');
    if (localStorage.getItem('userId') == 'Z02SAHME') {
      event.preventDefault();
      this.setState({
        loading: true,
      });
      Cookie.set('currentUser', {
        roles: this.state.data['userInfo']['roles'],
        token: this.state.data['userInfo']['token'],
        moduleAccess: this.state.data['userInfo']['moduleAccess'],
        userId: this.state.data['userInfo']['user_id'],
        emailId: this.state.data['userInfo']['email_id'],
        givenName: this.state.data['userInfo']['givenName'],
        surName: this.state.data['userInfo']['surname'],
        designation: this.state.data['userInfo']['designation'],
      });

      Cookie.set(
        'stores',
        this.state.data['userInfo']['storesInfos'][1]['storeLocationsInfos']
      );
      Cookie.set(
        'warehouses',
        this.state.data['userInfo']['storesInfos'][0]['storeLocationsInfos']
      );

      this.setState({
        loading: false,
        login: true,
      });
    } else {
      this.setState({
        modalOpen: !this.state.modalOpen,
        message: 'Something went wrong please try again after sometime',
        loading: false,
      });
    }
  }; */

  async componentDidMount() {
    console.log('State is initialized');
    this.setState({
      loading: true,
    });
    let search = window.location.search;

    let params = new URLSearchParams(search);

    let code = params.get('code');

    let token = '';
    Cookie.set('token', JSON.stringify(token), {
      secure: true,
      httpOnly: true,
      sameSite: 'strict',
    });
    localStorage.setItem('token',JSON.stringify(token))
    let redirectionMenu = [];
    let urlRedirect = '';
    let some = false;

    if (code) {
      console.log('Code is generated for token');
      const requestOptions = {
        crossDomain: true,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': process.env.REACT_APP_X_API_KEY,
        },
      };

      const response = await fetch(
        /* '/dsi_aristi/aristi-auth-response/?code=' + */
        process.env.REACT_APP_SERVER +
          '/dsi_aristi/aristi-auth-response/?code=' +
          // '/dsi_aristi_v1/aristi-auth-response/?code=' +
          code +
          '&appType=' +
          process.env.REACT_APP_APP_TYPE,
        requestOptions
      )
        .then((response) => response.json())
        .then((response) => {
          console.log(JSON.stringify(response));
          if (response.errorMessage === 'Invalid/Expired Code, null') {
            console.log(
              'Something went wrong please try again after sometime.'
            );
          }

          if (
            response.errorMessage === 'Invalid/Expired Code, 400 Bad Request' ||
            response.errorMessage
          ) {
            var cookies = document.cookie.split(';');

            for (var i = 0; i < cookies.length; i++) {
              var cookie = cookies[i];
              var eqPos = cookie.indexOf('=');
              var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
              document.cookie =
                name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
            }
            localStorage.removeItem('Login');

            Cookie.remove('currentUser');
            Cookie.remove('stores');
            Cookie.remove('storesAll');
            Cookie.remove('warehouses');

            localStorage.clear();
            sessionStorage.clear();
            return (window.location = '/');
          } else {
            this.setState({
              token: response.token,
            });
            console.log('Token is generated');
            console.log(JSON.stringify(response.token));
            Cookie.set('token', JSON.stringify(response.token), {
              secure: true,
              sameSite: 'strict',
            });
            localStorage.setItem('token', JSON.stringify(response.token))
          }
        })
        .catch((error) => {
          // alert(error);
          this.setState({
            modalOpen: !this.state.modalOpen,
            message: 'Something went wrong please try again after sometime',
            loading: false,
          });
        });
    } else {
      this.setState({
        modalOpen: !this.state.modalOpen,
        message: 'Not able to login now. please try again after sometime',
        loading: false,
      });
    }

    await ApiGateWay.paramsPost(
      this.state.apiInterface + `/fetchUserInfo`,
      JSON.parse(Cookie.get('token'))
    )
      .then((response) => {if(response.status === "Success"){
        this.props.isLoginOrNot(true)
        localStorage.setItem("isLogin", true)
      }else{
        this.props.isLoginOrNot(false)
        localStorage.setItem("isLogin",false)
      }
        if (
          response.errorMessage === 'Token Expired' ||
          response.errorMessage === 'Invalid Token:::JWT expired' ||
          response.errorMessage ===
            'Your session has expired. Please login again.'
        ) {
          this.setState({
            loading: false,
            modalOpen: true,
            message: response.errorMessage,
          });
          return (window.location = '/');
        }
        if (response) {
          console.log('All the user info is generated.');
          console.log(response, '[response]');
          response['userInfo']['moduleAccess'][0]['featureAccess'].map(
            (featureAccess) => {
              if (featureAccess.value == 1) {
                redirectionMenu.push(featureAccess.featureName);

                console.log('Dashboard redirection link is pushed.');
              } else {
                const dataString = JSON.stringify({
                  roles: response['userInfo']['roles'],
                  token: response['userInfo']['token'],
                  moduleAccess: response['userInfo']['moduleAccess'],
                  userId: response['userInfo']['user_id'],
                  emailId: response['userInfo']['email_id'],
                  givenName: response['userInfo']['givenName'],
                  surName: response['userInfo']['surname'],
                  designation: response['userInfo']['designation'],
                },
                {
                  secure: true,
                  sameSite: 'strict',
                });
                const compressedData = LZString.compressToBase64(dataString);
                Cookie.set(
                  'currentUser',
                  compressedData
                );
                localStorage.setItem('currentUser', dataString)
                console.log('Some error in dashboard redirection');
                // setTimeout(() => {
                //   this.setState({
                //     redirectionURL: '/notAllowed',
                //     notAllowed: true,
                //     login: true,
                //   });
                // }, 1000);
              }
            }
          );
          // if (redirectionMenu[0] === "Delivery Efficiency Dashboard") {
          //   urlRedirect = '/DeliveryEfficiency';
          // }
          if (redirectionMenu[0] === 'Global Dashboard - Retail') {
            urlRedirect = '/dashboardRetail';
          } else if (redirectionMenu[0] === 'Store Dashboard') {
            urlRedirect = '/storeDashboardRetail';
          } else if (redirectionMenu[0] === 'Global Dashboard - Logistics') {
            urlRedirect = '/dashboardWareHouse';
          } else if (redirectionMenu[0] === 'Warehouse Dashboard') {
            urlRedirect = '/storeDashboardWareHouse';
          } 
          else if(redirectionMenu[0] === "Assets") {
            urlRedirect ='/Assets'
          }
          else if(redirectionMenu[0] === "Asset Category") {
            urlRedirect ='/AssetCategories'
          }
          else if(redirectionMenu[0] === "Store Identity Card"){
            urlRedirect ='/Stores'
          }
          else if(redirectionMenu[0] === "Warehouse Identity Card"){
            urlRedirect ='/Warehouses'
          }
          else if(redirectionMenu[0] === "PMP"){
            urlRedirect ='/PMPVendorList'
          }
          else if(redirectionMenu[0] === "PMP - Vendor"){
            urlRedirect ='/PMPVendorList'
          }
          else if(redirectionMenu[0] === "Maintenance Request"){
            urlRedirect ='/WorkOrderVendor'
          }
          else if(redirectionMenu[0] === "WorkOrder Vendor"){
            urlRedirect ='/WorkOrderVendor'
          }
          else if(redirectionMenu[0] === "Quotation Vendor"){
            urlRedirect ='/QuotationVendor'
          }
          // else if(redirectionMenu[0] === "Waste Management Dashboard"){
          //   urlRedirect ='/WasteManagementDashboard'
          // }
          else {
            this.setState({
              redirectionURL: '/notAllowed',
              notAllowed: true,
              login: true,
            });
          }
          
          let currentUserData =  {
            roles: response['userInfo']['roles'],
            token: response['userInfo']['token'],
            moduleAccess: response['userInfo']['moduleAccess'],
            userId: response['userInfo']['user_id'],
            emailId: response['userInfo']['email_id'],
            givenName: response['userInfo']['givenName'],
            surName: response['userInfo']['surname'],
            designation: response['userInfo']['designation'],
          }
          console.log('Hellooo');
          // const dataString = JSON.stringify(currentUserData);
          // const compressedData = LZString.compressToBase64(dataString);
          // this.setCookie(compressedData);
          const dataString = JSON.stringify(            {
            roles: response['userInfo']['roles'],
            token: response['userInfo']['token'],
            moduleAccess: response['userInfo']['moduleAccess'],
            userId: response['userInfo']['user_id'],
            emailId: response['userInfo']['email_id'],
            givenName: response['userInfo']['givenName'],
            surName: response['userInfo']['surname'],
            designation: response['userInfo']['designation'],
          },
          {
            secure: true,
            sameSite: 'strict',
          });
          const compressedData = LZString.compressToBase64(dataString);
          Cookie.set(
            'currentUser',
            compressedData
          );
          const decompressedData = LZString.decompressFromBase64(compressedData);
          const jsonData = JSON.stringify(decompressedData);
          localStorage.setItem('currentUser', JSON.parse(jsonData));
          this.setState({
            redirectionURL: urlRedirect,
            userID: response['userInfo']['user_id'],
            loading: false,
            login: true,
          });
          ApiGateWay.Post(this.state.apiInterface + `/cities`, {
            userId: response['userInfo']['user_id'],
            storeType: 'Store',
          })
            .then((response) => response.json())
            .then((response) => {
              if (
                response.errorMessage === 'Token Expired' ||
                response.errorMessage === 'Invalid Token:::JWT expired' ||
                response.errorMessage ===
                  'Your session has expired. Please login again.'
              ) {
                Cookie.remove('currentUser');
                Cookie.remove('stores');
                Cookie.remove('storesAll');
                Cookie.remove('warehouses');

                localStorage.clear();
                sessionStorage.clear();
                this.setState({
                  loading: false,
                  modalOpen: true,
                  message:
                    'Your session has been expired and you will be redirected to the login page!!',
                });
                setTimeout(() => {
                  return (window.location = '/');
                }, 4000);
              }
              localStorage.setItem('CitiesForStores', JSON.stringify(response));
              localStorage.setItem(
                'CitiesForCityStores',
                JSON.stringify(response)
              );

              //alert(JSON.stringify(response));
              console.log('Cities for store are generated');
              this.setState({
                storeCities: response,
                storeCityEnabled: true,
              });
            })
            .catch(() => {
              this.setState({
                modalOpen: !this.state.modalOpen,
                message:
                  'Something went wrong please try again after sometime!!',
                loading: false,
              });
            });
          ApiGateWay.Post(this.state.apiInterface + `/cities`, {
            userId: response['userInfo']['user_id'],
            storeType: '',
          })
            .then((response) => response.json())
            .then((response) => {
              if (
                response.errorMessage === 'Token Expired' ||
                response.errorMessage === 'Invalid Token:::JWT expired' ||
                response.errorMessage ===
                  'Your session has expired. Please login again.'
              ) {
                Cookie.remove('currentUser');
                Cookie.remove('stores');
                Cookie.remove('storesAll');
                Cookie.remove('warehouses');

                localStorage.clear();
                sessionStorage.clear();
                this.setState({
                  loading: false,
                  modalOpen: true,
                  message:
                    'Your session has been expired and you will be redirected to the login page!!',
                });
                setTimeout(() => {
                  return (window.location = '/');
                }, 4000);
              }
              localStorage.setItem('CitiesIncidents', JSON.stringify(response));

              //alert(JSON.stringify(response));
              console.log('Cities for store are generated');
              this.setState({
                storeCities: response,
                storeCityEnabled: true,
              });
            })
            .catch(() => {
              this.setState({
                modalOpen: !this.state.modalOpen,
                message:
                  'Something went wrong please try again after sometime!!',
                loading: false,
              });
            });
          ApiGateWay.Post(this.state.apiInterface + `/cities`, {
            userId: response['userInfo']['user_id'],
            storeType: 'Warehouse',
          })
            .then((response) => response.json())
            .then((response) => {
              if (
                response.errorMessage === 'Token Expired' ||
                response.errorMessage === 'Invalid Token:::JWT expired' ||
                response.errorMessage ===
                  'Your session has expired. Please login again.'
              ) {
                Cookie.remove('currentUser');
                Cookie.remove('stores');
                Cookie.remove('storesAll');
                Cookie.remove('warehouses');

                localStorage.clear();
                sessionStorage.clear();
                this.setState({
                  loading: false,
                  modalOpen: true,
                  message:
                    'Your session has been expired and you will be redirected to the login page!!',
                });
                setTimeout(() => {
                  return (window.location = '/');
                }, 4000);
              }
              localStorage.setItem(
                'CitiesForWarehouse',
                JSON.stringify(response)
              );

              //alert(JSON.stringify(response));
              console.log('Cities for warehouse are generated');
              this.setState({
                warehouseCities: response,
                warehouseCityEnabled: true,
              });
            })
            .catch(() => {
              this.setState({
                modalOpen: !this.state.modalOpen,
                message:
                  'Something went wrong please try again after sometime!!',
                loading: false,
              });
            });
          console.log(Cookie.get('currentUser'));
        }
      })
      .catch(() => {
        this.setState({
          modalOpen: !this.state.modalOpen,
          message: 'Something went wrong please try again after sometime',
          loading: false,
        });
      });

    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    ApiGateWay.Post(this.state.apiInterface + `/fetchStoreInfo`, {
      userId: currentUser.userId,
      cityIds: '',
      appType: 'Web',
      
    })
      .then((response) => response.json())
      .then((response) => {
        if (
          response.errorMessage === 'Token Expired' ||
          response.errorMessage === 'Invalid Token:::JWT expired' ||
          response.errorMessage ===
            'Your session has expired. Please login again.'
        ) {
          Cookie.remove('currentUser');
          Cookie.remove('stores');
          Cookie.remove('storesAll');
          Cookie.remove('warehouses');

          localStorage.clear();
          sessionStorage.clear();
          this.setState({
            loading: false,
            modalOpen: true,
            message:
              'Your session has been expired and you will be redirected to the login page!!',
          });
          setTimeout(() => {
            return (window.location = '/');
          }, 4000);
        }

        if (response['storesInfos'][0]['storeType'] === 'Store') {
          localStorage.setItem(
            'storeData',
            JSON.stringify(response['storesInfos'][0]['storeLocationsInfos'])
          );
          localStorage.setItem(
            'warehouseData',
            JSON.stringify(response['storesInfos'][1]['storeLocationsInfos'])
          );
          localStorage.setItem(
            'storeData1',
            JSON.stringify(response['storesInfos'][0]['storeLocationsInfos'])
          );
          localStorage.setItem(
            'storeData3',
            JSON.stringify(response['storesInfos'][0]['storeLocationsInfos'])
          );
          localStorage.setItem(
            'warehouseData1',
            JSON.stringify(response['storesInfos'][1]['storeLocationsInfos'])
          );

          response['storesInfos'][0]['storeLocationsInfos']
            .sort((a, b) => (a.cityName > b.cityName ? 1 : -1))
            .map((val) => {
              if (val.currentStore === 1) {
                localStorage.setItem('currentCityForDashboard', val.cityId);
                localStorage.setItem('currentCityForCityDashboard', val.cityId);
                // localStorage.setItem('cityForDashboardStore', val.cityId);
              }
            });
          response['storesInfos'][1]['storeLocationsInfos']
            .sort((a, b) => (a.cityName > b.cityName ? 1 : -1))
            .map((val) => {
              if (val.currentStore === 1) {
                localStorage.setItem('currentCityForWareHouse', val.cityId);
                //localStorage.setItem('cityForWareHouseStore', val.cityId);
              }
            });
          this.setState({
            navigate: true,
            strData: response['storesInfos'][0]['storeLocationsInfos'],
            wrData: response['storesInfos'][1]['storeLocationsInfos'],
          });
          console.log('store are generated');
        } else if (response['storesInfos'][0]['storeType'] === 'Warehouse') {
          localStorage.setItem(
            'storeData',
            JSON.stringify(response['storesInfos'][1]['storeLocationsInfos'])
          );
          localStorage.setItem(
            'warehouseData',
            JSON.stringify(response['storesInfos'][0]['storeLocationsInfos'])
          );
          localStorage.setItem(
            'storeData1',
            JSON.stringify(response['storesInfos'][1]['storeLocationsInfos'])
          );
          localStorage.setItem(
            'storeData3',
            JSON.stringify(response['storesInfos'][1]['storeLocationsInfos'])
          );
          localStorage.setItem(
            'warehouseData1',
            JSON.stringify(response['storesInfos'][0]['storeLocationsInfos'])
          );
          response['storesInfos'][1]['storeLocationsInfos'].map((val) => {
            if (val.currentStore === 1) {
              localStorage.setItem('currentCityForDashboard', val.cityId);
              localStorage.setItem('currentCityForCityDashboard', val.cityId);
              // localStorage.setItem('cityForDashboardStore', val.cityId);
            }
          });
          response['storesInfos'][0]['storeLocationsInfos'].map((val) => {
            if (val.currentStore === 1) {
              localStorage.setItem('currentCityForWareHouse', val.cityId);
              // localStorage.setItem('cityForWareHouseStore', val.cityId);
            }
          });
          this.setState({
            navigate: true,
            strData: response['storesInfos'][1]['storeLocationsInfos'],
            wrData: response['storesInfos'][0]['storeLocationsInfos'],
          });
          console.log("Warehouse store's are generated");
        } else if (response == [] || response['storesInfos'] == []) {
          console.log(response['storesInfos']);
          this.setState({
            redirectionURL: '/notAllowed',
            notAllowed: true,
            login: true,
          });
        } else {
          console.log('some');
          this.setState({
            redirectionURL: '/notAllowed',
            notAllowed: true,
            login: true,
          });
        }
      })
      .catch(() => {
        this.setState({
          navigate: false,
          modalOpen: !this.state.modalOpen,
          message: 'Something went wrong please try again after sometime',
          loading: false,
        });
      });
  }

  render() {
    // alert(this.state.login);
    if (this.state.login === true && this.state.navigate) {
      const user = Cookie.get('currentUser');
      const decompressedData = LZString.decompressFromBase64(user);
      const jsonData = JSON.stringify(decompressedData);
      console.log(JSON.parse(jsonData));
      setTimeout(() => {
        console.log(localStorage.getItem('CitiesForStores'));
        console.log(localStorage.getItem('CitiesForWarehouse'));
      }, 2000);
      console.log('Redirection is done');
      localStorage.setItem(
        'DashboardPath',
        this.state.redirectionURL
      );
      return <Navigate to={this.state.redirectionURL} />;

     
    } else if (this.state.login === true && this.state.notAllowed) {
      console.log('Redirection is done for not allowed page');
      return <Navigate to={'/notAllowed'} />;
    }
    const style = {
      display: 'block',
      marginTop: '15%',
      marginLeft: 'auto',
      marginRight: 'auto',
      textAlign: 'center',
      width: '50%',
      background: 'white',
      marginBottom: '25%',
    };
    const welHeader = {
      fontWeight: 'bold',
      fontSize: '600%',
      color: ' #3c8dbc',
      fontFamily: 'Roboto Condensed',
      fontStyle: 'italic',
    };

    return (
      <>
        <Helmet>
          {' '}
          <title>{'Welcome to Decathlon'}</title>{' '}
        </Helmet>
        <div className='wrapper' style={{ background: 'white' }}>
          <div className='content-wrapper10'>
            <div className='align-center' style={style}>
              <h1 style={welHeader}>Welcome To</h1>
              <img src='/dist/img/welcome.png' alt='Welcome' />
            </div>
          </div>
        </div>
      </>
    );
  }
}
const mapDispatchToProps = dispatch =>({
  ...bindActionCreators({isLoginOrNot},dispatch)
})
const mapStateToProps = state =>({
})
export default connect(mapStateToProps, mapDispatchToProps) (Welcome);
